export interface LightPreset {
  name: string;
  desc: string;
  exposure: number;
  hemisphere: { intensity: number; groundColor: number };
  dirLight1: {
    position: [number, number, number];
    intensity: number;
    shadowSize: number;
  };
  dirLight2: {
    position: [number, number, number];
    intensity: number;
    color: string;
  } | null;
  pointLights: Array<{
    position: [number, number, number];
    intensity: number;
    distance: number;
    color: string;
  }>;
  ceilingEmissive: number;
  mainRoom: {
    panelEmissive: number;
  };
  utilityRoom: {
    panelEmissive: number;
  };
  mezzanine: {
    lights: Array<{
      position: [number, number, number];
      intensity: number;
      distance: number;
      color: string;
    }>;
    floorEmissive: number;
    ceilingEmissive: number;
  };
}

export const PRESET: LightPreset = {
  name: "Cấp 1",
  desc: "Sáng nhất - như store thật",
  exposure: 1.5,
  hemisphere: { intensity: 5.0, groundColor: 0x996633 }, // Tăng từ 1.1 lên 2.0 để bù đắp
  dirLight1: {
    position: [8, 15, 0],
    intensity: 3, // Tăng từ 2.5 lên 3.5
    shadowSize: 2048, // 4096² = ~64MB VRAM + slow first-frame render; 2048² is ample here
  },
  dirLight2: {
    position: [-10, 14, -6],
    intensity: 0.9,
    color: "#ffcc88",
  },
  pointLights: [
    { position: [0, 7, 2], intensity: 0.8, distance: 16, color: "#fff8f0" },
    { position: [0, 7, -10], intensity: 0.8, distance: 16, color: "#fff8f0" },
    { position: [0, 7, -18], intensity: 0.7, distance: 15, color: "#fff8f0" },
    { position: [-12, 5, 15], intensity: 0.5, distance: 12, color: "#fff8f0" },
    { position: [12, 5, 0], intensity: 0.5, distance: 12, color: "#fff8f0" },
  ],
  ceilingEmissive: 1.0,
  mainRoom: {
    panelEmissive: 0.8,
  },
  utilityRoom: {
    panelEmissive: 0.7,
  },
  mezzanine: {
    lights: [
      { position: [-6, 10.6, 7], intensity: 1.2, distance: 14, color: "#fff5e6" },
      { position: [6, 10.6, 7], intensity: 1.2, distance: 14, color: "#fff5e6" },
      { position: [0, 10.6, -12], intensity: 1.2, distance: 14, color: "#fff5e6" },
      { position: [0, 10.6, 10], intensity: 0.7, distance: 14, color: "#fff5e6" },
    ],
    floorEmissive: 0.5,
    ceilingEmissive: 0.45,
  },
};

